// ============================================================
// Aktif kiracı ve şube erişimi
//
// Kiracılık modeli:
//   tenant (kiracı) = müşteri kurum   → DATA.tenants[]
//   branch (şube)   = kurumun şubesi  → tenant.branches[]
//
// EN ÖNEMLİ KURAL: şube araması ASLA tüm veri kümesinde yapılmaz,
// yalnızca aktif kiracının şubeleri içinde yapılır. Bu yüzden kod
// DATA.tenants üzerinde gezinmez, buradaki yardımcılardan geçer.
// Böylece kiracılar arası sızıntı, kod yazarken hatırlamaya değil,
// yapının kendisine bağlı olur.
// ============================================================

import { DATA } from "../data/store.js";
import { state } from "../state.js";

// ---------- Kiracı ----------

/** Aktif kiracı (müşteri kurum). */
export const T = () => DATA.tenants.find(t => t.id === state.tenantId) ?? DATA.tenants[0];

/** Kimliğe göre kiracı — yalnızca sistem operatörü kullanır. */
export const kiraciBul = tenantId => DATA.tenants.find(t => t.id === tenantId) ?? null;

/** Tüm kiracılar — erişimi auth katmanı sınırlar. */
export const tumKiracilar = () => DATA.tenants;

// ---------- Şube ----------

/** Bir kiracının şubeleri; parametresizse aktif kiracının. */
export const subeler = tenantId =>
  (tenantId ? kiraciBul(tenantId)?.branches ?? [] : T().branches);

/**
 * Şubeyi kimliğe göre bulur — ARAMA KİRACIYLA SINIRLIDIR.
 * Başka kiracının şubesi istenirse null döner.
 */
export const subeBul = (branchId, tenantId) =>
  subeler(tenantId).find(b => b.id === branchId) ?? null;

/** Aktif şube. */
export const B = () => subeBul(state.branchId) ?? subeler()[0];

/** Bir şubenin bağlı olduğu kiracı — şube kimliğinden kiracıyı çözer. */
export const subeninKiracisi = branchId =>
  DATA.tenants.find(t => t.branches.some(b => b.id === branchId)) ?? null;

/**
 * TÜM kiracıların şubeleri — kiracı sınırını BİLEREK aşar.
 *
 * Yalnızca iki yerde meşrudur:
 *   1. Açılış türetmeleri (fatura geçmişi, yoklama geçmişi, veri bağlama) —
 *      bunlar kullanıcı sorgusu değil, tohum verinin hazırlanmasıdır.
 *   2. Sistem operatörü ekranları.
 *
 * Kullanıcıya veri döndüren hiçbir yol buradan geçmemeli; onlar
 * subeler() / subeBul() kullanır. Ayrı ve uzun adlı olmasının sebebi
 * yanlışlıkla çağrılmasını zorlaştırmaktır.
 */
export const tumSubeler = () => DATA.tenants.flatMap(t => t.branches);

/** Kiracı gözetmeksizin şube arar — kullanım kuralı tumSubeler() ile aynı. */
export const subeBulHerYerde = branchId =>
  tumSubeler().find(b => b.id === branchId) ?? null;

/**
 * Bir işi geçici olarak başka bir şubenin bağlamında çalıştırır.
 *
 * KİRACIYI DA AYARLAR. Yalnızca state.branchId değiştirmek yetmez:
 * B() araması kiracıyla sınırlı olduğu için, başka kiracının şubesine
 * geçildiğinde arama boşa düşer ve aktif kiracının ilk şubesine
 * gerilenir — hesaplar sessizce yanlış tarifeden yapılır.
 */
export function subeBaglaminda(branchId, isle) {
  const kiraci = subeninKiracisi(branchId);
  const oncekiKiraci = state.tenantId;
  const oncekiSube = state.branchId;
  try {
    if (kiraci) state.tenantId = kiraci.id;
    state.branchId = branchId;
    return isle();
  } finally {
    state.tenantId = oncekiKiraci;
    state.branchId = oncekiSube;
  }
}

// ---------- Aktif şube içi kısayollar ----------

export const cls = id => B().classes.find(c => c.id === id);
export const stu = id => B().students.find(s => s.id === id);
export const staffOf = id => B().staff.find(p => p.id === id);
export const personOf = (kind, id) => (kind === "student" ? stu(id) : staffOf(id));
